import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { QuickClockModal } from '../components/QuickClock';

export default function Kiosk() {
  const [open, setOpen] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    document.body.classList.add('kiosk-mode');
    setMounted(true);
    return () => {
      document.body.classList.remove('kiosk-mode');
    };
  }, []);

  const handleOpenChange = (val) => {
    if (!val) {
      setTimeout(() => setOpen(true), 500);
    }
  };

  const logo = (
    <div
      style={{
        position: 'fixed',
        top: 32,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        zIndex: 100,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          background: '#f97316',
          borderRadius: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          boxShadow: '0 4px 14px rgba(249,115,22,0.3)',
        }}
      >
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>RS</span>
      </div>
      <span style={{ fontWeight: 700, fontSize: 22, color: '#0f172a', fontFamily: 'Manrope, sans-serif' }}>
        ReStaff
      </span>
    </div>
  );

  return (
    <>
      <style>{`
        body.kiosk-mode { background: #f8fafc !important; }
        body.kiosk-mode [data-radix-dialog-overlay],
        body.kiosk-mode [data-state="open"].fixed.inset-0 {
          background: #f8fafc !important;
          opacity: 1 !important;
        }
      `}</style>

      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: '#f8fafc',
          overflow: 'hidden',
        }}
      />

      <QuickClockModal open={open} onOpenChange={handleOpenChange} />

      {/* Logo rendered into body portal — paints above dialog overlay */}
      {mounted && ReactDOM.createPortal(logo, document.body)}
    </>
  );
}
